module.exports = __webpack_public_path__ + "img/ultra_1_03.535be4f4.jpg";